import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { useAppSelector } from "src/store";
import { createClientCancellationReasonSaga } from "src/store/clientcancelreason/saga";
import * as Yup from "yup";

const ClientCancellationReasonCreateForm = ({
  onHide,
  open,
  onSuccessClick,
}: {
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("ClientCancellationReason.CreateFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Content: "",
          Translates: languages.map((x) => {
            return { LanguageId: x.EnumId, Content: "" };
          }),
        }}
        onSubmit={(values) => {
          dispatch(
            createClientCancellationReasonSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          Content: Yup.string().required(t("Validation.Required").toString()),
          Translates: Yup.array(
            Yup.object({
              Content: Yup.string().required(
                t("Validation.Required").toString()
              ),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "Content",
            label: t("ClientCancellationReason.Content").toString(),
          },
        ]}
      />
    </React.Fragment>
  );
};
export default ClientCancellationReasonCreateForm;
